import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';

import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
    private authService = inject(AuthService);
;

    canActivate() {
        if (!this.authService.isLoggedIn()) {
            this.authService.handleLogin();
            return false;
        }
        // Item 4: sessão expirada (>2h) → invalida, limpa cookies e volta ao login.
        if (this.authService.isSessionExpired()) {
            this.authService.logout();
            return false;
        }
        return true;
    }

}